import {
  Stack,
  useFocusEffect,
  useLocalSearchParams,
  useNavigation,
} from "expo-router";
import { StackActions } from "@react-navigation/native";

import { CollectionForm } from "~/components/CollectionForm";
import { HeaderX } from "~/components/HeaderElements";
import { useAccountStore } from "~/stores/space";

export default function SelectSpace() {
  const { store } = useAccountStore();

  const localParams = useLocalSearchParams<{
    spaceId: string;
    collectionId?: string;
  }>();
  const { spaceId, collectionId } = localParams;
  const space = store.spaceById(spaceId!);

  const navigation = useNavigation();

  const accountLayout = useNavigation("/(app)/(authenticated)/[account]");
  useFocusEffect(() => {
    accountLayout.setOptions({
      sheetAllowedDetents: "fitToContents",
    });
  });

  return (
    <>
      <Stack.Screen
        options={{
          headerTitle: collectionId
            ? `Update collection`
            : `New collection in ${space?.slug}`,
          headerBackVisible: true,
          headerRight: ({}) => {
            return (
              <HeaderX
                onPress={() => {
                  // If this ever breaks, try the commented code.
                  navigation.getParent()?.dispatch(StackActions.pop());
                  // if (navigation.getState().routes.length > 1) {
                  //   navigation.dispatch(StackActions.popToTop());
                  //   push("../");
                  // } else {
                  //   push("../");
                  // }
                }}
              />
            );
          },
        }}
      />

      <CollectionForm spaceId={spaceId!} collectionId={collectionId} />
    </>
  );
}
